import React, { useCallback, useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { debounce } from 'lodash';

const TableRowInput = ({ placeholder = 'Search', defaultValue = '', onSearchChange, debounceTime = 1000 }) => {
    const [value, setValue] = useState("");

    useEffect(() => {
        setValue(defaultValue);
    }, [defaultValue])

    const debouncedSearchChange = useCallback(
        debounce((value) => {
            if (onSearchChange) {
                onSearchChange(value);
            }
        }, debounceTime),
        [onSearchChange, debounceTime]
    );

    const handleSearchChange = (e) => {
        let value = e.target.value.replace(/[^0-9.]/g, ''); 

        const parts = value.split('.');
        if (parts.length > 2) {
            value = parts[0] + '.' + parts.slice(1).join('');
        }
        setValue(value);
        debouncedSearchChange(value);
    };


    return (
        <div className='d-flex align-items-center' style={{ position: "relative" }}>
            <span style={{ position: "absolute", left: "10px" }}>$</span>
            <Form.Control
                type="text"
                placeholder={placeholder}
                className="search-input"
                aria-label="Search"
                value={value}
                onChange={handleSearchChange}
                style={{ border: 0, background: "#f5f6fa", padding: "0 20px", display: "flex", alignItems: "center" }}
                maxLength={15}
            />
        </div>
    );
};

export default TableRowInput;
